import React from "react";
import { PackagingType } from "../../../services/medicationmanagement/medications";
import { SelectableMedication } from "../usePharmacyMedications";

export const PharmacyMedicationProductDisplay = (props: {
    item: SelectableMedication;
}) => {
    let displayString : string = '';
    


    if(props.item.packagingType !== PackagingType.None && props.item.packagingType != null)
    {
        if(displayString.length > 0  )
            displayString = displayString + " . ";
            
        displayString = displayString + props.item.packagingType;
    }

    if(displayString.length > 0  )
        displayString = displayString ;
        if(props.item.product?.repeats!=null){
            displayString = displayString + " . " + "Repeats:" +  props.item.product?.repeats;
        }
        
  
    return <div>{displayString}</div>
}
